import { UserRoles } from '@onereach/auth-ui-module';
import type { MenuItem } from '@onereach/service-navigation';
import { ComponentCustomProperties } from 'vue';

import isContactsV1Enabled from './isContactsV1Enabled';
import isContactsV2Enabled from './isContactsV2Enabled';

function getMenuItems($t: ComponentCustomProperties['$t'], role: UserRoles = UserRoles.user): MenuItem[] {
  const menuItems: MenuItem[] = [];
  const hasSettings = role === UserRoles.admin || role === UserRoles.superAdmin;

  if (isContactsV2Enabled()) {
    if (isContactsV1Enabled() || hasSettings) {
      menuItems.push({
        label: $t('menuItems.contactBooks'),
        url: '/books',
      });
    }

    if (isContactsV1Enabled()) {
      menuItems.push({
        label: $t('menuItems.oldContactBooks'),
        url: '/contact-books',
      });
    }
  } else if (isContactsV1Enabled()) {
    menuItems.push(
      {
        label: $t('menuItems.contactBooks'),
        url: '/contact-books',
      },
      {
        label: $t('menuItems.visibilityRules'),
        url: '/visibility-rules',
      },
    );
  }

  if (hasSettings) {
    menuItems.push({
      label: $t('menuItems.settings'),
      url: '/settings',
    });
  }

  return menuItems;
}
export default getMenuItems;
